import React from 'react';

import ColorConstants from '@shared/constants/ColorConstants';

import { OPTION_WRAPPER_TEST_IDS } from './option-wrapper.constants';
import { Wrapper, StyledCheckBox } from './option-wrapper.styles';
import { LabelComponent } from './label-component';

interface IOptionWrapper {
    checked: Boolean;
    checkedColor: string;
    children: React.ComponentType;
    className: string;
    isAdvancedMetric: Boolean;
    isVisible: Boolean;
    label: string;
    onClick: Function;
}

export const OptionWrapper = ({
    checked,
    checkedColor,
    children,
    className,
    isAdvancedMetric,
    isVisible,
    label,
    onClick,
}: IOptionWrapper) => (
    <Wrapper
        className={className}
        data-testid={isAdvancedMetric
            ? OPTION_WRAPPER_TEST_IDS.MULTI_SELECTOR.ADVANCED_METRIC
            : OPTION_WRAPPER_TEST_IDS.MULTI_SELECTOR.OPTION_VALUE
        }
        isVisible={isVisible}
        onClick={onClick}
    >
        <StyledCheckBox
            checked={checked}
            unCheckedColor={ColorConstants['catskill-white']}
            checkedColor={checkedColor}
            label={label}
        />
        <LabelComponent label={label} src={null} />
        {children}
    </Wrapper>
);
